import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './AllInclude.scss';
import translations from '../../assets/locales/messages_en.json';
import {
  Contact,
  SEOTools,
  Inbox,
  Workflows,
  TasksReminders,
  Marketing,
} from './AllIncludeIcons';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';

export interface AllIncludeProps
  extends WithTranslation,
    InjectedExperimentsProps {}

class AllInclude extends React.Component<AllIncludeProps> {
  PREFIX_TITLE = 'allInclude.title.';
  PREFIX_DESCRIPTION = 'allInclude.description.';
  PREFIX_ICON = 'allInclude.icon.';

  getIcon = (id: string) => {
    const arrayOfKeys = Object.keys(translations);
    const arrayOfValues = Object.values(translations);

    const findIndex = arrayOfKeys.indexOf(`${this.PREFIX_ICON}${id}`);
    const translatedObjectName = arrayOfValues[findIndex];

    switch (translatedObjectName) {
      case 'SEOTools':
        return <SEOTools />;
      case 'Contact':
        return <Contact />;
      case 'Inbox':
        return <Inbox />;
      case 'Workflows':
        return <Workflows />;
      case 'TasksReminders':
        return <TasksReminders />;
      case 'Marketing':
        return <Marketing />;
      default:
        return <SEOTools />;
    }
  };

  allIncludeKeys = () => {
    return Object.keys(translations)
      .filter((str) => str.startsWith(this.PREFIX_TITLE))
      .map((str) => str.substring(this.PREFIX_TITLE.length));
  };

  render() {
    const { t } = this.props;
    const allIncludeKeysArray = this.allIncludeKeys();

    return (
      <div className={s.strip} data-hook="allInclude-strip">
        <div className={classNames(s.root)} data-hook="allInclude">
          <div className={s.title} data-hook="allInclude-title">
            {t('allInclude.title')}
          </div>
          <div className={s.subtitle}>{t('allInclude.subtitle')}</div>
          <div
            className={s.listOfBenefits}
            data-hook="allInclude-listOfBenefits"
          >
            {allIncludeKeysArray.map((id) => (
              <div
                key={id}
                className={s.benefit}
                data-hook="allInclude-benefit"
              >
                <div
                  className={s.benefitIcon}
                  data-hook={`allInclude-benefitIcon-${id}`}
                >
                  {this.getIcon(id)}
                </div>
                <div
                  className={s.benefitTextBox}
                  data-hook="allInclude-benefitTextBox"
                >
                  <div
                    className={s.benefitTitle}
                    data-hook={`allInclude-benefitTitle-${id}`}
                  >
                    {t(`${this.PREFIX_TITLE}${id}`)}
                  </div>
                  <div
                    className={s.benefitDescription}
                    data-hook={`allInclude-benefitDescription-${id}`}
                  >
                    {t(`${this.PREFIX_DESCRIPTION}${id}`)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withExperiments(AllInclude));
